export enum BroadcastType {
  EXTERNAL = "external",
  PARTY = "party",
  PREMIUM = "premium",
  PUBLIC = "public",
}

export enum StreamStartType {
  IOS = "ios",
  OBS = "obs",
  Regular = "regular",
}

export enum BroadcastDesktopLobbySettingsAreaViewType {
  Default = "default",
  Gifts = "gifts",
  StreamSettings = "streamSettings",
}

export enum IOSStreamingType {
  Boarcast = "boarcast",
  Larix = "larix",
  Prism = "prism",
  Streamlabs = "streamlabs",
}
